import LoadingGraphic from './LoadingGraphic'

export const Spinner = () => (
	<div style={{display: 'flex', justifyContent: 'center'}}>
		<LoadingGraphic width='60' alt='loading' aria-label='Loading' />
	</div>
)
